import { createAction } from "@reduxjs/toolkit";
import * as ACTIONTYPES from "../action-types/univers";

const UNIVERS_GET_REQUEST_ACTION = createAction(ACTIONTYPES.UNIVERS_GET_REQUEST);
const UNIVERS_GET_SUCCESS_ACTION = createAction<any, string>(ACTIONTYPES.UNIVERS_GET_SUCCESS);
const UNIVERS_GET_ERROR_ACTION = createAction<any, string>(ACTIONTYPES.UNIVERS_GET_ERROR);

export { UNIVERS_GET_REQUEST_ACTION, UNIVERS_GET_SUCCESS_ACTION, UNIVERS_GET_ERROR_ACTION };
